module.exports = __webpack_public_path__ + "img/freestyle_box30.05dfa736.jpg";